import { STATS, TRUST_BADGES } from "@/data/content";
import { ShieldCheck } from "lucide-react";

export const TrustBar = () => {
  return (
    <section data-testid="trust-bar" className="bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-slate-200">
          {STATS.map((s) => (
            <div key={s.label} className="py-8 px-4 text-center">
              <p className="text-3xl sm:text-4xl font-extrabold font-display text-[#1c4f9c]">{s.value}</p>
              <p className="mt-1 text-xs sm:text-sm font-medium text-slate-500">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 py-6 border-t border-slate-200">
          {TRUST_BADGES.map((b) => (
            <span key={b} className="flex items-center gap-2 text-sm font-semibold text-slate-600">
              <ShieldCheck size={16} className="text-[#e02329]" /> {b}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
